(function () {
  if (window.__tukNewsletterConfirmationBound) return;
  window.__tukNewsletterConfirmationBound = true;

  function setSubmitting(form, isSubmitting) {
    var submit = form.querySelector('[type="submit"]');
    if (!submit) return;

    submit.disabled = isSubmitting;
    submit.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
  }

  function showMessage(form, type, title, message) {
    var currentMessage = form.querySelector('.tuk-newsletter-banner__message');
    var fields = form.querySelector('.tuk-newsletter-banner__fields');

    if (currentMessage) currentMessage.remove();

    var status = document.createElement('div');
    status.className = 'tuk-newsletter-banner__message tuk-newsletter-banner__message--' + type;
    status.setAttribute('role', type === 'success' ? 'status' : 'alert');
    status.setAttribute('aria-live', type === 'success' ? 'polite' : 'assertive');
    status.setAttribute('tabindex', '-1');

    if (type === 'success') {
      status.innerHTML =
        '<span class="tuk-newsletter-banner__message-icon" aria-hidden="true"></span>' +
        '<span class="tuk-newsletter-banner__message-copy"><strong>' + title + '</strong><span>' + message + '</span></span>';
      if (fields) fields.remove();
    } else {
      status.textContent = message;
    }

    form.prepend(status);
    status.focus({ preventScroll: true });
  }

  function submitWithShopifyProtection(form) {
    var returnTo = form.querySelector('input[name="return_to"]');

    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.appendChild(returnTo);
    }

    returnTo.value = window.location.pathname + '#newsletter-signup';
    delete form.dataset.tukSubmitting;
    setSubmitting(form, false);
    HTMLFormElement.prototype.submit.call(form);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('.tuk-newsletter-banner__form');
      if (!form || form.dataset.tukSubmitting === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      form.dataset.tukSubmitting = 'true';
      setSubmitting(form, true);

      var scrollPosition = {
        x: window.scrollX,
        y: window.scrollY
      };

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
        credentials: 'same-origin',
        redirect: 'follow'
      })
        .then(function (response) {
          return response.text().then(function (html) {
            return { response: response, html: html };
          });
        })
        .then(function (result) {
          var responseUrl = result.response.url || '';
          var returnedPage = new DOMParser().parseFromString(result.html, 'text/html');
          var challengeRequested =
            responseUrl.indexOf('/challenge') !== -1 ||
            returnedPage.querySelector('.shopify-challenge__container');

          if (challengeRequested) {
            if (responseUrl.indexOf('/challenge') !== -1) {
              window.location.assign(responseUrl);
            } else {
              submitWithShopifyProtection(form);
            }
            return;
          }

          var returnedError = returnedPage.querySelector(
            '.tuk-newsletter-banner__message--error, .errors, [data-form-error]'
          );

          if (!result.response.ok || returnedError) {
            throw new Error(returnedError ? returnedError.textContent.trim() : 'Unable to sign up. Please try again.');
          }

          showMessage(form, 'success', "You're all set!", 'Thank you for signing up.');

          requestAnimationFrame(function () {
            window.scrollTo(scrollPosition.x, scrollPosition.y);
          });

          document.dispatchEvent(
            new CustomEvent('showAlert', {
              detail: {
                type: 'success',
                message: "You're all set! Thank you for signing up."
              }
            })
          );
        })
        .catch(function () {
          submitWithShopifyProtection(form);
        })
        .finally(function () {
          delete form.dataset.tukSubmitting;
          setSubmitting(form, false);
        });
    },
    true
  );
})();
